<script setup lang="ts">
interface Props {
  loading: boolean
}

withDefaults(defineProps<Props>(), {
  loading: true,
})
</script>

<template>
  <div>
    <transition name="loader">
      <div v-show="loading" class="loader-overlay" role="status" aria-live="polite">
        <div class="loader">
          <div class="loader-logo" aria-hidden="true">
            <img src="/svg/payjib-logo.svg" alt="" class="loader-logo__img" />
            <span class="loader-logo__shine" />
          </div>
          <!-- <p class="loader-text">
            <span class="loader-dots" aria-hidden="true">
              <span>.</span><span>.</span><span>.</span>
            </span>
          </p> -->
        </div>
      </div>
    </transition>
    <slot />
  </div>
</template>

<style scoped>
.loader-overlay {
  position: fixed;
  inset: 0;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(234, 238, 245, 0.72);
  -webkit-backdrop-filter: blur(8px);
  backdrop-filter: blur(8px);
}

.loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

.loader-logo {
  position: relative;
  width: 140px;
  animation: loader-breathe 2s ease-in-out infinite;
}

.loader-logo__img {
  display: block;
  width: 100%;
  height: auto;
}

.loader-logo__shine {
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.9), transparent);
  background-size: 200% 100%;
  -webkit-mask-image: url('/svg/payjib-logo.svg');
  mask-image: url('/svg/payjib-logo.svg');
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-size: contain;
  mask-size: contain;
  -webkit-mask-position: center;
  mask-position: center;
  animation: loader-shine 1.6s linear infinite;
}

.loader-text {
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 0;
  color: #1b325a;
  font-family: IRANSans, serif;
  font-size: 15px;
  font-weight: 500;
}

.loader-dots {
  display: inline-flex;
}

.loader-dots span {
  font-size: 22px;
  line-height: 1;
  animation: loader-blink 1.4s ease-in-out infinite both;
}

.loader-dots span:nth-child(2) {
  animation-delay: 0.2s;
}

.loader-dots span:nth-child(3) {
  animation-delay: 0.4s;
}

.loader-enter-active,
.loader-leave-active {
  transition: opacity 0.25s ease;
}

.loader-enter-from,
.loader-leave-to {
  opacity: 0;
}

@keyframes loader-breathe {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.85;
    transform: scale(0.97);
  }
}

@keyframes loader-shine {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

@keyframes loader-blink {
  0%,
  80%,
  100% {
    opacity: 0;
    transform: translateY(0);
  }
  40% {
    opacity: 1;
    transform: translateY(-3px);
  }
}
</style>
